export function externalSetter<T, K extends keyof T>(data: T, field: K, setOriginalState:(value:T | ((last: T)=>T))=>void):(value:(T[K]) | ((last:T[K])=>T[K]))=>void{
    return (value)=>{
        
        if (typeof value == 'function'){
            setOriginalState((last)=>({...last, [field]: (value as ((last:T[typeof field])=>T[typeof field]))(last[field])}));
        } else {
            setOriginalState((last)=>({...last, [field]: value}));
        }
    }
}